import cloneDeep from 'lodash/cloneDeep';

export default function generateDataExcel(reseauxTempo, i18n) {
  let dataExcel = [];
  dataExcel.push({
    reference: i18n.t('popUpParametrageReseauTempoDispo.tab.reference'),
    libelle: i18n.t('popUpParametrageReseauTempoDispo.tab.libelle'),
    ville: i18n.t('popUpParametrageReseauTempoDispo.tab.ville'),
    departement: i18n.t('popUpParametrageReseauTempoDispo.tab.departement'),
    format: i18n.t('popUpParametrageReseauTempoDispo.tab.format'),
    facesPrevues: i18n.t('popUpParametrageReseauTempoDispo.tab.facePrevues'),
    facesReelles: i18n.t('popUpParametrageReseauTempoDispo.tab.faceReelles'),
    dateDebut: i18n.t('popUpParametrageReseauTempoDispo.tab.depart'),
    semaine: i18n.t('popUpParametrageReseauTempoDispo.tab.semaine'),
    annee: i18n.t('popUpParametrageReseauTempoDispo.tab.annee'),
    tarifCurrency: i18n.t('popUpParametrageReseauTempoDispo.tab.tarif'),
    taxeCurrency: i18n.t('popUpParametrageReseauTempoDispo.tab.taxe'),
    fraisCurrency: i18n.t('popUpParametrageReseauTempoDispo.tab.frais'),
    etat: i18n.t('popUpParametrageReseauTempoDispo.tab.etat'),
    resteAVendre: i18n.t('popUpParametrageReseauTempoDispo.tab.resteAVendre'),
  });
  const reseauxTempoForExcel = cloneDeep(reseauxTempo);
  reseauxTempoForExcel.forEach((reseauTempo) => {
    delete reseauTempo.affectations;
    delete reseauTempo.facesNonDispo;
    delete reseauTempo.id;
    delete reseauTempo.tarif;
    delete reseauTempo.taxe;
    delete reseauTempo.frais;
  });
  dataExcel = dataExcel.concat(reseauxTempoForExcel);
  return dataExcel;
}
